module.exports = __webpack_public_path__ + "static/media/skills-mapping-img-003.cbc469ab.jpg";